import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import AppointmentBooking from "../appointmentBooking";
import { CalendarViewsProvider } from "../../../components/business/calendar/view/calendarViewsProvider";
import { GET_BUSINESS_BOOKING_TYPES } from "../../../graphql/queries";
import { useQuery } from "@apollo/client";
const BookingTypePage = (props) => {
  const { businessUrl, bookingTypeLink } = useParams();

  const {
    loading,
    error,
    data: businessBookingTypes,
  } = useQuery(GET_BUSINESS_BOOKING_TYPES, {
    variables: {
      businessUrl
    }
  }); 

  // Add null check and fallback for bookingTypeLink
  const link = props.preview ? props.bookingTypeLink : (bookingTypeLink || props.bookingTypeLink);

  // Find the booking type from allBookingTypes
  const bookingType = businessBookingTypes?.getBusinessBookingTypes?.find((obj) => obj.link === link); 
  const [selectedStaffId, setSelectedStaffId] = useState(0);
  const [isItLoading, setIsItLoading] = useState(false);
 
  useEffect(() => {
    if (isItLoading) {
      setTimeout(() => {
        setIsItLoading(false);
      }, 600);
    }
  }, [isItLoading]);

  if (loading) {
    return "Loading...";
  }

  if (error) {
    return "Error";
  }

  if (!bookingType && !props.preview) {
    return <div>Booking type not found.</div>; // Provide a fallback message when no booking type is found
  }
 
  return (
    <CalendarViewsProvider>
      <AppointmentBooking
          selectedBookingData={bookingType}
          selectedStaffId={selectedStaffId}
          businessUrl={businessUrl}
      />
    </CalendarViewsProvider>
  );
};

export default BookingTypePage;
